import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Input, Button } from "@heroui/react";
import { sendEmailRecovery } from "../services/api";
import { toast } from "react-toastify";
import { getLogoBase64 } from "../utils/themeManager";

export function ForgotPasswordPage() {
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [isLinkSent] = useState(false);

  const handleSendResetLink = async () => {
    // In a real application, this would call an API to send a password reset link
    // For now, we'll just simulate the process
    if (email.trim()) {
      // setIsLinkSent(true);
      const user = await sendEmailRecovery(email);
      if (user) {
        toast.success(
          "As informações para redefinição da senha foram enviadas para o e-mail informado",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
          }
        );
        history.push("/");
      } else {
        toast.error(
          "Erro ao enviar o e-mail de recuperação de senha. Por favor, tente novamente mais tarde!",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
          }
        );
      }
    } else {
      alert("Por favor, insira um email válido");
    }
  };

  const handleBackToLogin = () => {
    history.push("/");
  };

  return (
    <div className="bg-primary-500 min-h-screen flex flex-col">
      <div
        style={{ height: "30vh" }}
        className="flex items-center justify-center"
      >
        <img src={getLogoBase64()} alt="PlayBPO" className="h-24" />
      </div>

      <div
        style={{
          height: "70vh",
          borderTopLeftRadius: 70,
          borderTopRightRadius: "0px",
        }}
        className="bg-white w-full overflow-hidden"
      >
        <div className="max-w-md mx-auto pt-12 px-6 relative h-full">
          <h1 className="text-2xl font-bold text-center mb-8">
            {isLinkSent ? "Link enviado" : "Esqueci minha senha"}
          </h1>

          {!isLinkSent ? (
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <Input
                  placeholder="Digite seu e-mail"
                  value={email}
                  onValueChange={setEmail}
                  variant="bordered"
                  radius="lg"
                  classNames={{
                    input: "bg-gray-50",
                  }}
                />
              </div>

              <Button
                color="primary"
                onPress={handleSendResetLink}
                className="w-full text-secondary rounded-xl py-6"
              >
                Enviar link de recuperação
              </Button>

              <Button
                variant="light"
                onPress={handleBackToLogin}
                className="w-full text-gray-500 rounded-xl py-6"
              >
                Voltar para login
              </Button>
            </div>
          ) : (
            <div className="text-center space-y-6">
              <div className="bg-green-50 border border-green-200 rounded-xl p-6">
                <p className="text-green-700">
                  Um link de recuperação de senha foi enviado para{" "}
                  <strong>{email}</strong>. Verifique sua caixa de entrada.
                </p>
              </div>

              <Button
                color="primary"
                onPress={handleBackToLogin}
                className="w-full text-white rounded-xl py-6"
              >
                Voltar para login
              </Button>
            </div>
          )}

          <div style={{ height: 90 }}></div>
          <div className="absolute bottom-8 left-0 right-0 flex justify-center">
            <img
              src="https://suporte.sistemaplaybpo.com.br/hc/theming_assets/01HZPJPWCTBQYAF2R9S527JNNG"
              alt="PlayBPO"
              style={{ height: "30px" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
